// Module
var code = "<a ng-click=\"$ctrl.showItemBidsDialog()\" translate> detail_des_encheres </a> ";
// Exports
module.exports = code;